import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Search, PenLine, Plane } from "lucide-react";

const steps = [
  { num: "01", icon: Search, titleKey: "step1_title", descKey: "step1_desc", color: "#1e3a5f" },
  { num: "02", icon: PenLine, titleKey: "step2_title", descKey: "step2_desc", color: "#f97316" },
  { num: "03", icon: Plane, titleKey: "step3_title", descKey: "step3_desc", color: "#22c55e" },
];

export default function HowItWorks() {
  const { t } = useTranslation();

  return (
    <section id="how-it-works" className="py-24 md:py-32 bg-[#f8fafc]" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl font-semibold tracking-tight text-[#1e3a5f]">
            {t("how_it_works.title")}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {steps.map((step, i) => (
            <motion.div
              key={step.num}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              className="relative bg-white border border-[#e2e8f0] rounded-2xl p-8 overflow-hidden group hover:shadow-md hover:scale-[1.02] transition-all duration-300"
              data-testid={`how-it-works-step-${i + 1}`}
            >
              {/* Background number */}
              <span className="absolute -top-4 -right-2 text-[120px] font-['Outfit'] font-bold text-[#f8fafc] select-none pointer-events-none group-hover:text-[#f1f5f9] transition-colors">
                {step.num}
              </span>

              <div className="relative z-10">
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6"
                  style={{ backgroundColor: `${step.color}10` }}
                >
                  <step.icon className="w-7 h-7" style={{ color: step.color }} />
                </div>
                <h3 className="font-['Outfit'] text-xl font-semibold text-[#1e3a5f] mb-3">
                  {t(`how_it_works.${step.titleKey}`)}
                </h3>
                <p className="text-[#6b7280] text-sm leading-relaxed">
                  {t(`how_it_works.${step.descKey}`)}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
